<!-- <app-loader></app-loader> -->
<app-notification></app-notification>
<router-outlet></router-outlet>
